<template>
  <Transition
    enter-from-class="opacity-0"
    enter-active-class="ease-out duration-200"
    enter-to-class="opacity-100"
    leave-from-class="opacity-100"
    leave-active-class="ease-in duration-100"
    leave-to-class="opacity-0"
    appear
  >
    <div v-if="state.show" class="cookie-banner">
      <div class="text text-xs mb-6">
        <h3>Cookie-Einstellungen</h3>
        <p>Unsere Webseite nutzt verschiedene Cookies, die für den sicheren Betrieb unserer Webseite technisch notwendig sind, die aber auch zur besseren Bedienbarkeit unserer Webseite und zur Anzeige personalisierter Inhalte eingesetzt werden. Unter den nachstehenden Cookie Kategorien und anderer technischer Systeme können Sie durch entsprechendes Anklicken wählen, soweit es sich nicht um notwendige Cookies handelt.</p>
        <p>Durch das Anklicken des Buttons "Alle Cookies akzeptieren" erklären Sie Ihr Einverständnis damit, dass wir alle hierdurch eingesetzten Cookies nutzen dürfen. Sie können Ihre erteilte Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen, indem Sie die entsprechenden, nicht "notwendigen" Kategorien in den Cookie Einstellungen, die Sie unter dem dort jeweils benannten Link finden, deaktivieren.</p>
        <p>Weitere Informationen zu den von uns genutzten Cookies finden Sie in unserer <Link :href="route('pages.data-protection')">Datenschutzerklärung</Link>.</p>
      </div>
      <div class="mb-6 space-y-4">
        <CookieFeature
          v-model="features.essential"
          label="Essenziell"
          disabled
        >
          <p>
            Essenzielle Cookies ermöglichen grundlegende Funktionen und sind für die einwandfreie Funktion der Website erforderlich.
          </p>
          <p>
            <strong>Domain</strong><br>
            dasda-tickets.de
          </p>
          <p>
            <Link :href="route('pages.data-protection')">Datenschutzerklärung</Link>
          </p>
        </CookieFeature>
        <CookieFeature
          v-model="features.facebook"
          label="Facebook Pixel"
        >
          <p>
            Der Facebook-Pixel hilft dabei festzustellen, ob du die Zielgruppe für die Präsentation von Anzeigen innerhalb des Facebook-Werbenetzwerks bist. Der Facebook-Pixel ermöglicht es auch die Wirksamkeit von Facebook-Werbung zu verfolgen. Mit der zusätzlichen Funktion “extended comparison” werden in deinem Facebook-Konto gespeicherte Informationen, wie z.B. E-Mail-Adressen oder Facebook-IDs von Nutzern in verschlüsselter Form zielgruppengerecht verwendet. Cookies werden verwendet, um Nutzer zu unterscheiden und ihr Verhalten auf der Website im Detail aufzuzeichnen und diese Daten mit Werbedaten aus dem Facebook-Werbenetzwerk zu verknüpfen. Diese Daten können mit den Daten der auf facebook.com mit ihren Facebook-Konten registrierten Nutzer verknüpft werden.
          </p>
          <p>
            <strong>Anbieter</strong><br>
            Meta (formerly Facebook)
          </p>
          <p>
            <strong>Domain</strong><br>
            connect.facebook.net, static.xx.fbcdn.net
          </p>
          <p>
            <a href="https://www.facebook.com/legal/terms" target="_blank">Nutzungsbedingungen</a><br>
            <a href="https://www.facebook.com/privacy/policy" target="_blank">Datenrichtlinie</a>
          </p>
        </CookieFeature>
      </div>
      <footer class="flex flex-wrap gap-4">
        <button
          class="button"
          type="button"
          @click="acceptAll()"
        >
          Alle Cookies akzeptieren
        </button>
        <button
          class="button button--ghost"
          type="button"
          @click="acceptSelected()"
        >
          Auswahl bestätigen
        </button>
      </footer>
    </div>
  </Transition>
</template>

<script setup>
import Link from './Link.vue';
import CookieFeature from './CookieFeature.vue';
import { onMounted, reactive } from 'vue';
import * as handlers from '@/features/index.js';
import cookies from '@/helpers/cookies';

const state = reactive({
  show: false,
});

const features = reactive({
  essential: true,
  facebook: false,
});

function handle(key, value) {
  if (key in handlers)
    handlers[key].set(value);
}

function acceptAll() {
  Object.keys(features).forEach(key => {
    handle(key, true)
  });

  state.show = false;
}

function acceptSelected() {
  Object.keys(features).forEach(key => {
    handle(key, features[key])
  });

  state.show = false;
}

onMounted(() => {
  state.show = cookies.get('FEATURE-ESSENTIAL') !== 'true';
});

</script>
